import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * One canonical URL per route, on the apex host.
 *
 * The site answers on the apex and on `www`, and a static `<link
 * rel="canonical">` in index.html would point every route at the landing page.
 * So index.html carries the apex root as the default and this keeps the href in
 * step with the router: known routes get their own path, the catch-all gets
 * none (a not-found page has nothing to be canonical for).
 */
const ORIGIN = 'https://sleeplessintel.xyz';
const ROUTES = new Set(['/', '/terminal', '/honest-numbers']);

export function Canonical() {
  const { pathname } = useLocation();
  useEffect(() => {
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    if (!ROUTES.has(path)) {
      link?.remove();
      return;
    }
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = `${ORIGIN}${path}`;
  }, [pathname]);
  return null;
}
